import React, { useRef, useEffect, useState } from "react";
import "../Styles/PropertyCarousel.css";
import api from "../Api";
import hotel_img from "../Images/hotelimg.jpg";
import { useNavigate } from "react-router-dom";
import grouptour from "../Images/grouptour1.jpg";
import packagetour from "../Images/packagetour1.jpg";
import customtour from "../Images/plantour1.jpg";
import weekendtour from "../Images/weekendtour1.jpg";
import transportimg from "../Images/transport_coverimg.png";
import activity from "../Images/activity.jpg";

const PropertyCarousel = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hotelData, setHotelData] = useState([]);
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  // useEffect(() => {
  //   const fetchHotels = async () => {
  //     try {
  //       const res = await api.get("/hotels");
  //       if (res.data.status === true) {
  //         console.log("Fetched hotels:", res.data.data);
  //         setHotelData(res.data.data || []);
  //       }
  //     } catch (err) {
  //       console.error("Error fetching hotels:", err);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  //   fetchHotels();
  // }, []);

  // Navigation handlers — same pattern as Happy Customers
  const handleScroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    const amount = container.offsetWidth / 4;
    container.scrollBy({
      left: direction === "right" ? amount : -amount,
      behavior: "smooth",
    });
  };

  const data = [
    {
      img:
        "https://img.magnific.com/premium-photo/luxury-villa-with-large-swimming-pool-both-indoors-outdoors_1257429-40747.jpg?semt=ais_hybrid&w=740&q=80" ||
        hotel_img,
      title: "Hotel",
      link: "/hotels",
    },
    { img: "https://img.magnific.com/free-photo/young-friends-top-mountain-enjoying-mesmerizing-view_181624-30260.jpg?semt=ais_hybrid&w=740&q=80" || grouptour, title: "Group Tour", link: "/tour/grouptour" },
    { img:"https://img.magnific.com/free-vector/tropical-vacation-air-travel-service-composition_98292-6990.jpg?semt=ais_hybrid&w=740&q=80"|| packagetour, title: "Package Tour", link: "/tour/packagetour" },
    { img: "https://img.magnific.com/premium-vector/travel-planning-illustration-workspace-with-vacation-preparation-stuff-trip-booking-online-tour_726899-149.jpg?semt=ais_hybrid&w=740&q=80"|| customtour, title: "Plan Tour", link: "/tour/plantour" },
    { img: "https://img.magnific.com/free-photo/happy-hipster-company-friends-traveling-around-world_285396-3650.jpg?semt=ais_hybrid&w=740&q=80"|| weekendtour, title: "Weekend Tour", link: "/tour/weekendtour" },
    { img: "https://www.shutterstock.com/image-photo/yellow-cab-renault-cheerful-girl-260nw-2682488937.jpg?semt=ais_hybrid&w=740&q=80" || transportimg, title: "Book Cab", link: "/transports" },
    { img: "https://images.unsplash.com/photo-1592208128295-5aaa34f1d72b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGFyYWdsaWRpbmd8ZW58MHx8MHx8fDA%3D" || activity, title: "Your favourite Activity", link: "/activities" },
  ];

  return (
    <section className="pc-wrapper">
      <div className="pc-header">
        <div className="pc-title-block">
          <h3 className="pc-headline">Browse by Category</h3>
          <p className="pc-subtext">
            From castles and villas to boats and igloos, we've got it all
          </p>
        </div>
        <div className="pc-controls">
          <button onClick={() => handleScroll("left")} aria-label="Previous">
            ◀
          </button>
          <button onClick={() => handleScroll("right")} aria-label="Next">
            ▶
          </button>
        </div>
      </div>

      <div className="pc-track" ref={scrollRef}>
        {data.map((item, index) => (
          <div
            className="pc-card"
            key={index}
            onClick={() => navigate(`${item.link}`)}
          >
            <div className="pc-image">
              <img
                src={item.img || hotel_img}
                alt={item.title}
                loading="lazy"
              />
            </div>
            <h4 className="pc-card-title">{item.title}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PropertyCarousel;